import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TagModel } from '@hub/models/tag.model';

@Component({
    selector: 'tag-list',
    templateUrl: 'tag-list.component.html'
})
export class TagListComponent {

    constructor() {
        this.em = new EventEmitter<TagModel>();
    }

    @Input() tags: TagModel[];
    @Output() em: EventEmitter<TagModel>;

    ClickFunction(value: TagModel): void {
        this.em.emit(value);
    }

}
